

<script>
import { Pie } from 'vue-chartjs'
import { setTimeout } from 'timers';
export default {
  extends: Pie,
  data() {
      return {
          comsession:0,
          cosession:0,
          rusession:0,
          piedata:[]
      }
  },
  mounted () {
         this.setData()
     
    this.renderChart({
      labels: ['onedio.com','onedio.co','onedio.ru'],
      datasets: [
        {
          backgroundColor: [
            '#20a8d8',
            '#ffc107',
            '#4dbd74'
          ],
          data:this.piedata
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  },
  methods: {
     async setData(){
        this.comsession=parseInt(this.$store.state.comSession.replace(/\./g,""))
        this.cosession=parseInt(this.$store.state.coSession.replace(/\./g,""))
        this.rusession=parseInt(this.$store.state.ruSession.replace(/\./g,""))
        this.piedata.push(this.comsession)
        this.piedata.push(this.cosession)
        this.piedata.push(this.rusession)
      }
  },
}
</script>
